export default "__VITE_ASSET__CSXsPPcL__"